import { API_BASE_URL } from "../../constant/constant";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  PageContainer,
  Title,
  Description,
  InputContainer,
  Input,
  NextButton,
  AvatarDiv,
  SelectContainer,
  Select,
} from "./style";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const AvatarInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [avatarName, setAvatarName] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [greetingLanguage, setGreetingLanguage] = useState("dutch");

  const [existingAvatar, setExistingAvatar] = useState(null);
  const {t}=useTranslation();

  const imageId = location.state?.imageId || ""; // Get imageId from state
  const userId = localStorage.getItem("id");

  useEffect(() => {
    const checkExistingAvatar = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/auth/get-avatar?user_id=${userId}`
        );
        
        const data = await response.json();
        
        if (data.responseCode === 200) {
          setExistingAvatar(data.avatar);
          setAvatarName(data.avatar.avatarName);
          setGreetingLanguage(data.avatar.greetingLanguage);
        } else if (data.responseCode === 404) {
          setExistingAvatar(null);
        }
      } catch (error) {
        console.error("Error checking existing avatar:", error);
      } finally {
        setLoading(false);
      }
    };
    checkExistingAvatar();
  }, [userId]);

  const handleBackClick = () => {
    navigate("/avatar-selection");
  };

  const handleNextClick = async () => {
    setLoadingNext(true);

    try {
      const apiUrl = existingAvatar 
        ? `${API_BASE_URL}/api/auth/update-avatar`
        : `${API_BASE_URL}/api/auth/add-avatar`;

      const payload = {
        user_id: userId,
        avatarName: avatarName.trim(),
        imageId: imageId,
        greetingLanguage: greetingLanguage
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        // localStorage.setItem('avatarName', avatarName.trim());
        const isOnboarded = localStorage.getItem('isOnboarded') === 'true';
        navigate(isOnboarded ? "/avatar-chat" : "/");
      } else {
        console.error("Failed to add/update avatar.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoadingNext(false);
    }
  };

  // If still loading, show circular progress
  if (loading) {
    return (
      <PageContainer>
        <CircularProgress />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <AvatarDiv>
        <Title>{t("steps.name")}</Title>
        <Description>
         Kies een naam voor je gepersonaliseerde AI-assistent en kijk hoe hij/zij je ideeën tot leven brengt!
        </Description>
        <InputContainer>
          <Input
            type="text"
            placeholder="Enter Name"
            value={avatarName}
            onChange={(e) => setAvatarName(e.target.value)}
          />
        </InputContainer>
        <SelectContainer>
          <Select
            value={greetingLanguage}
            onChange={(e) => setGreetingLanguage(e.target.value)}
          >
            <option value="english">English</option>
            <option value="dutch">Nederlands</option>
          </Select>
        </SelectContainer>
        <div style={{ display: "flex" }}>
          <NextButton
            style={{ background: "none", color: "#313133" }}
            onClick={handleBackClick}
          >
           {t("steps.back")}
          </NextButton>
          <NextButton onClick={handleNextClick} disabled={loading}>
            {loadingNext ? <CircularProgress size={24} /> : t("steps.next")}
          </NextButton>
        </div>
      </AvatarDiv>
    </PageContainer>
  );
};

export default AvatarInfo;